export const ESTADOS = {
  FACTURADO: 311,
  FACTURADO_ALT: 245,
  ANULADO: 328
};

export const STATUS_CONFIG = {
  [ESTADOS.FACTURADO]: { color: "success", label: "Facturado" },
  [ESTADOS.FACTURADO_ALT]: { color: "success", label: "Facturado" },
  [ESTADOS.ANULADO]: { color: "error", label: "Anulado" }
};

export const TABLE_INITIAL_STATE = {
  density: "compact",
  pagination: { pageIndex: 0, pageSize: 50 },
  columnPinning: { right: ["mrt-row-actions"] },
  grouping: ["fecha_format", "sucursal_cliente"]
};